<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="queryParams.name"
          class="!w-240px"
          clearable
          placeholder="请输入姓名"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="queryParams.phone"
          class="!w-240px"
          clearable
          placeholder="请输入手机号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="员工状态" prop="status">
        <el-select
          v-model="queryParams.status"
          class="!w-240px"
          clearable
          placeholder="请选择员工状态"
        >
          <el-option label="在职" value="ACTIVE" />
          <el-option label="休假" value="LEAVE" />
          <el-option label="离职" value="RESIGNED" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:employee:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="工号" prop="employeeNo" min-width="100" />
      <el-table-column align="center" label="姓名" prop="name" min-width="100" />
      <el-table-column align="center" label="手机号" prop="phone" min-width="120" />
      <el-table-column align="center" label="岗位编码" prop="positionCode" min-width="100" />
      <el-table-column align="center" label="雇佣类型" prop="employmentType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.employmentType === 'EMPLOYEE'" type="primary">正式员工</el-tag>
          <el-tag v-else-if="scope.row.employmentType === 'PARTNER'" type="success">合作伙伴</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="员工状态" prop="status" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 'ACTIVE'" type="success">在职</el-tag>
          <el-tag v-else-if="scope.row.status === 'LEAVE'" type="warning">休假</el-tag>
          <el-tag v-else-if="scope.row.status === 'RESIGNED'" type="danger">离职</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="基本薪资" prop="baseSalary" min-width="100">
        <template #default="scope">
          {{ scope.row.baseSalary != null ? '￥' + scope.row.baseSalary : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="入职日期" prop="hireDate" min-width="120" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:employee:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:employee:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="岗位" prop="positionCode">
        <el-select v-model="formData.positionCode" placeholder="请选择岗位" filterable clearable>
          <el-option v-for="item in positionList" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="工号" prop="employeeNo">
        <el-input v-model="formData.employeeNo" placeholder="请输入工号" />
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formData.name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="formData.phone" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="雇佣类型" prop="employmentType">
        <el-radio-group v-model="formData.employmentType">
          <el-radio value="EMPLOYEE">正式员工</el-radio>
          <el-radio value="PARTNER">合作伙伴</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="员工状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio value="ACTIVE">在职</el-radio>
          <el-radio value="LEAVE">休假</el-radio>
          <el-radio value="RESIGNED">离职</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="基本薪资" prop="baseSalary">
        <el-input-number
          v-model="formData.baseSalary"
          :min="0"
          :precision="2"
          placeholder="请输入基本薪资"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="绩效比例" prop="performanceRatio">
        <el-input-number
          v-model="formData.performanceRatio"
          :min="0"
          :max="100"
          :precision="2"
          placeholder="请输入绩效比例"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="入职日期" prop="hireDate">
        <el-date-picker
          v-model="formData.hireDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择入职日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="离职日期" prop="resignDate">
        <el-date-picker
          v-model="formData.resignDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择离职日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="技能" prop="skills">
        <el-input v-model="formData.skills" placeholder="请输入技能(逗号分隔)" />
      </el-form-item>
      <el-form-item label="身份证号" prop="idNumber">
        <el-input v-model="formData.idNumber" placeholder="请输入身份证号" />
      </el-form-item>
      <el-form-item label="紧急联系人" prop="emergencyContact">
        <el-input v-model="formData.emergencyContact" placeholder="请输入紧急联系人" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as EmployeeApi from '@/api/hotel/employee'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { getPositionList } from '@/api/hotel/position'

defineOptions({ name: 'HotelEmployee' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

// 岗位下拉列表
const positionList = ref<any[]>([])
const getPositionListData = async () => {
  const data = await getPositionList()
  positionList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  name: undefined,
  phone: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await EmployeeApi.getEmployeePage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<EmployeeApi.EmployeeVO>({
  id: undefined,
  shopId: undefined,
  userId: undefined,
  employeeNo: '',
  name: '',
  phone: '',
  positionCode: '',
  employmentType: 'EMPLOYEE',
  status: 'ACTIVE',
  baseSalary: 0,
  performanceRatio: 0,
  hireDate: '',
  resignDate: undefined,
  skills: '',
  idNumber: '',
  emergencyContact: '',
  createTime: undefined as any
})
const formRules = reactive({
  employeeNo: [{ required: true, message: '工号不能为空', trigger: 'blur' }],
  name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
  phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
  positionCode: [{ required: true, message: '岗位不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await EmployeeApi.getEmployee(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await EmployeeApi.createEmployee(data)
      message.success(t('common.createSuccess'))
    } else {
      await EmployeeApi.updateEmployee(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: undefined,
    userId: undefined,
    employeeNo: '',
    name: '',
    phone: '',
    positionCode: '',
    employmentType: 'EMPLOYEE',
    status: 'ACTIVE',
    baseSalary: 0,
    performanceRatio: 0,
    hireDate: '',
    resignDate: undefined,
    skills: '',
    idNumber: '',
    emergencyContact: '',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await EmployeeApi.deleteEmployee(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
  getPositionListData()
})
</script>
